import background1 from './background1.png';
import background2 from './background2.png';
import background3 from './background3.png';
import background4 from './background4.png';
import background5 from './background5.png';
import background6 from './background6.png';
import background7 from './background7.png';
import background8 from './background8.png';
import background9 from './background9.png';
import background10 from './background10.png';
import background11 from './background11.png';
import background12 from './background12.png';
import background13 from './background13.png';
import background14 from './background14.png';
import background15 from './background15.png';
import background16 from './background16.png';
import background17 from './background17.png';
import background18 from './background18.png';
//import background19 from './background19.png';

let backgrounds = [ background1, background2, background3, background4, background5, background6, background7, background8, background9, background10, background11, background12, background13, background14, background15, background16, background17, background18 /*,background19*/ ];
export default backgrounds;



// WEBPACK FOOTER //
// ./src/img/backgrounds/Backgrounds.js